import { getDashboardStats } from "../../domain/dashboard"

export const DASHBOARD_SET = "DASHBOARD_SET"
export const DASHBOARD_REQUEST = "DASHBOARD_REQUEST"
export const DASHBOARD_REQUEST_DONE = "DASHBOARD_REQUEST_DONE"

export const setDashboard = data => ({ type: DASHBOARD_SET, payload: data })

export const dashboardRequest = () => ({ type: DASHBOARD_REQUEST })

export const dashboardRequestDone = () => ({ type: DASHBOARD_REQUEST_DONE })

export const getDashboard = (params = {}) => dispatch => {
	dispatch(dashboardRequest())
	return getDashboardStats(params).then(res => {
		dispatch(setDashboard(res.data.data))
		dispatch(dashboardRequestDone())
		return res.data.data
	})
}
